import { NavLink } from 'react-router-dom';
import { Link } from 'react-router-dom';

import { Add16 } from '@ingrid/iconography/react';
import { Breadcrumb, Button, InteractiveTable, PageTitle, PageWrapper } from '@ingrid/luterkort-react';

import { RoleGuard } from '~src/components/RoleGuard/RoleGuard';
import { useTranslation } from '~src/i18n/use-translation';
import { AppRoute } from '~src/main/routes';

import { useBookingRuleListQuery } from '../queries';
import { ListTable } from './components/list-table';

export function Page() {
  const { isFetching, data = [], isFetched } = useBookingRuleListQuery();
  const { t } = useTranslation();

  return (
    <InteractiveTable.Provider
      onHighlightedKeyChange={undefined}
      highlightedKey={undefined}
      selectedKeys={undefined}
      allowHighlight
      keepInactive
    >
      <PageWrapper>
        <PageTitle.Wrapper>
          <PageTitle.Stack>
            <Breadcrumb aria-label={t('common.breadcrumbs')}>
              <NavLink to="..">{t('common.settings')}</NavLink>
              <a aria-current="page">{t('common.bookingRules')}</a>
            </Breadcrumb>
          </PageTitle.Stack>
          <RoleGuard roles={['transport:edit']} withTooltip>
            <Button as={Link} to={AppRoute.EDIT}>
              <Add16 /> {t('common.create')}
            </Button>
          </RoleGuard>
        </PageTitle.Wrapper>

        <section style={{ backgroundColor: 'inherit' }}>
          <ListTable isEmpty={isFetched && !data?.length} data={data} isLoading={isFetching} />
        </section>
      </PageWrapper>
    </InteractiveTable.Provider>
  );
}
